// keycode definition
export const KeyCode = {
    Enter: 13,
    Esc: 27,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowRight: 39,
    ArrowDown: 40,
};
//# sourceMappingURL=keycode.js.map